import { render, staticRenderFns } from "./bankDc.vue?vue&type=template&id=c9c1cade&scoped=true"
import script from "./bankDc.vue?vue&type=script&lang=js"
export * from "./bankDc.vue?vue&type=script&lang=js"
import style0 from "./bankDc.vue?vue&type=style&index=0&id=c9c1cade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c1cade",
  null
  
)

export default component.exports